import { ImageType } from "@/pages/challenges/types/common";
import Image from "../base/Image";

interface ImageStoryProps {
  image: ImageType;
}

const ImageStory = ({ image }: ImageStoryProps) => {
  return (
    <Image
      alt="Story content"
      urls={image}
      size="medium"
      loading="eager"
      className="size-full"
    />
  );
};

export default ImageStory;


